/**
 * Menu component
 * 
 * @module component-menu
 * @version 1.0.0
 * @extends HTMLElement
 */

 customElements.component = 'component-menu';

 if (!customElements.get(customElements.component)) {

    class ComponentMenu extends HTMLElement {

        
    /**
     * Menu web component
     * 
     * @constructor
     */
    constructor() {

        super();

        this.closeMenu();
        this.initToggle();
        this.initSubmenu();
       
    }

    /**
	 * Init menu toggle buttons
     * 
     * @return {undefined}
	 */
    initToggle() {

        document.querySelectorAll('[data-menu-open]').forEach((element) => {
        

            element.addEventListener('click', (event) => {
                event.preventDefault();
                this.openMenu();
                this.activeToggle = event.target;
            });

        });

        document.querySelectorAll('[data-menu-close]').forEach((element) => {

            element.addEventListener('click', () => {
                this.closeMenu();
            });
        });

        // Close menu on window resize
        window.addEventListener('screen-breakpoint', event => {
            this.closeMenu();
        });

        // Close menu on press escape
        window.addEventListener('escape', event => {
            this.closeMenu();
        });


    }

     /**
     * Init submenus
     * 
     * @return {undefined}
     */
    initSubmenu() {

        this.closeAllSubmenus();

        const globalOverlay = document.querySelector('[data-global-overlay]');
        if (globalOverlay) {
            globalOverlay.addEventListener('click', (event) => {
                if (event.target === globalOverlay) {
                    this.closeAllSubmenus();
                    this.disableSubmenuFocusTrap();
                }
            });
        }

        // Open submenu on click
        document.querySelectorAll('[data-menu-submenu-target]').forEach((element) => {

            element.addEventListener('click', (event) => {

                event.preventDefault();

                this.activeSubmenu = event.target;

                let submenu = document.querySelector('[data-menu-submenu="'+ element.dataset.menuSubmenuTarget + '"]');

                this.openSubmenu(submenu);
            });
        });

        // Open submenu on hover only on desktop
        document.querySelectorAll('[data-menu-level1-link]').forEach((element) => {

            if (element.dataset.menuSubmenuTargetHover) {

                hoverintent(element, () => {
                    
                    if (window.screenMode == 'desktop-large') {
    
                        let submenu = document.querySelector('[data-menu-submenu="'+ element.dataset.menuSubmenuTargetHover + '"]');
                        
                        this.openSubmenu(submenu, true).then(result => {});
                    }
    
                }, () => { });

            } else {

                hoverintent(element, () => {                    
                    
                    if (window.screenMode == 'desktop-large') {
    
                        this.closeAllSubmenus();
                    }
    
                }, () => { });
            }
        });

        // Close submenu on leave hover only on desktop
        document.querySelector('header').addEventListener('mouseleave', (event) => {
                
            if (window.screenMode == 'desktop-large') {
                this.closeAllSubmenus();
                this.disableSubmenuFocusTrap();
            }
        });
    }

    
    /**
	 * Open a submenu
     * 
     * @param {object} submenu A submenu object.
     * @param {boolean} disable_focus Disable focus change after open the submenu.
     * @return {Promise} Boolean value.
	 */
     openSubmenu(submenu, disable_focus = false) {

        return new Promise((resolve, reject) => {

            // Close all submenus opened
            this.closeAllSubmenus(submenu);

            // Handle submenu attributes
            submenu.classList.add('active');
            submenu.classList.add('animation');
            submenu.setAttribute('aria-hidden', 'false');
            submenu.classList.remove('hidden');

            // Handle global attributes
            this.classList.add('active-submenu');
            document.querySelector('body').classList.add('active-menu');

            if (!disable_focus && window.screenMode === 'desktop-large') {
                this.enableGlobalOverlay();
                this.initSubmenuFocusTrap(submenu);
                this.activeSubmenuFocusTrap();
            }

            resolve(true);
        });
    }

    /**
	 * Close a submenu
     * 
     * @param {object} submenu A submenu object.
     * @return {Promise} Boolean value.
	 */
    closeSubmenu(submenu)  {

        return new Promise((resolve, reject) => {

            // Handle submenu attributes
            submenu.classList.remove('active');

            // Handle global attributes
            this.classList.remove('active-submenu');
            document.querySelector('body').classList.remove('active-menu');
            
            submenu.setAttribute('aria-hidden', 'true');
            submenu.classList.remove('animation');
            submenu.classList.add('hidden');

            resolve(true);
        });
    }

    /**
	 * Close all submenus
     * 
     * @param {object} submenuActived The active submenu.
     * @return {undefined}
	 */
    closeAllSubmenus(submenuActived)  {

        let submenus = document.querySelectorAll('[data-menu-submenu]');

        submenus.forEach(submenu => {

            if (submenuActived) {

                // This condition will avoid to close the active submenu
                if (submenuActived.dataset.menuSubmenu != submenu.dataset.menuSubmenu) {
                    this.closeSubmenu(submenu);
                }

            } else {
            
                this.closeSubmenu(submenu);
            }
        });

        this.disableSubmenuFocusTrap();
        this.disableGlobalOverlay();
    }

    /**
	 * Open menu
     * 
     * @return {undefined}
	 */
    openMenu() {

        this.classList.remove('hidden');

        document.querySelector('[data-menu-overlay]').classList.remove('hidden');

        this.setAttribute('aria-hidden', 'false');

        this.openStatus = true;

        setTimeout(() => {

            this.classList.add('active');

            document.body.classList.add('overflow-hidden');
            document.body.classList.add('fixed');
            document.body.classList.add('w-full');

            this.initFocusTrap();

            this.activeFocusTrap();
        
            this.querySelector('[data-menu-close]').focus();

        }, 50);   
    }

    /**
	 * Close menu
     * 
     * @return {undefined}
	 */
    closeMenu() {
        this.disableFocusTrap();

        this.classList.remove('active');

        document.body.classList.remove('overflow-hidden');
        document.body.classList.remove('fixed');
        document.body.classList.remove('w-full');

        document.querySelector('[data-menu-overlay]').classList.add('hidden');

            // We need to use set time out to avoid issues with menu animation
            setTimeout(() => {

                this.setAttribute('aria-hidden', 'true');

                if(this.activeToggle) this.activeToggle.focus();

                this.openStatus = false;

                this.classList.add('hidden');
            }, 500);
        
    }

    /**
	 * Init menu focus trap
     * 
     * @return {undefined}
	 */
    initFocusTrap() {

        this.focusTrap = focusTrap.createFocusTrap(this, {});
    }

    /**
	 * Disable menu focus trap
     * 
     * @return {undefined}
	 */
    disableFocusTrap() {

        if (this.focusTrap) {
            this.focusTrap.deactivate();
        }
    }

    /**
	 * Ative menu focus trap
     * 
     * @return {undefined}
	 */
    activeFocusTrap() {

        if (this.focusTrap) {
            this.focusTrap.activate();
        }
    }

    /**
	 * Init submenu focus trap
     * 
     * @return {undefined}
	 */
    initSubmenuFocusTrap(submenu)  {

        this.submenuFocusTrap = focusTrap.createFocusTrap(submenu, { 
            clickOutsideDeactivates: true,
            onDeactivate: () => {
                // When focus trap deactivates (click outside), close submenus
                this.closeAllSubmenus();
                this.disableSubmenuFocusTrap();
            }
        });
    }

    /**
	 * Active submenu focus trap
     * 
     * @return {undefined}
	 */
    activeSubmenuFocusTrap()  {
        
        if (this.submenuFocusTrap) {

            this.disableFocusTrap();
            this.submenuFocusTrap.activate();
        }
    }

    /**
	 * Disable submenu focus trap
     * 
     * @return {undefined}
	 */
    disableSubmenuFocusTrap() {
        
        if (this.submenuFocusTrap) {
            
            this.submenuFocusTrap.deactivate();
            this.submenuFocusTrap = null;

            // Only reactivate main menu focus trap if menu is still open
            if (this.openStatus) {
                this.initFocusTrap();
                this.activeFocusTrap();
            }
        }
    }

    /**
	 * Set submenu on top
     * 
     * @return {undefined}
	 */
    setSubmenuOnTop() {
        const header = document.querySelector('.header-section .header');
        const headerTabs = document.querySelector('.header-section .header__tabs');
        const alertMessage = document.querySelector('.section-alert-message');
        let headerHeight = header.offsetHeight;

        if (headerTabs) {
            headerHeight += headerTabs.offsetHeight;
        }

        if (window.pageYOffset <= 40 && document.querySelector("#shopify-section-alert-message").offsetHeight > 0 ) {
            document.querySelectorAll('[data-menu-submenu]').forEach(submenu => {
                submenu.style.top = alertMessage.offsetHeight + headerHeight + 'px';
            });
        } else {
            document.querySelectorAll('[data-menu-submenu]').forEach(submenu => {
                submenu.style.top = headerHeight + 'px';
            });
        }

        let debounceTimer;

        document.addEventListener('scroll', () => {
            clearTimeout(debounceTimer);
            debounceTimer = setTimeout(() => {
            if (window.pageYOffset <= 40 && document.querySelector("#shopify-section-alert-message").offsetHeight > 0 ) {
                document.querySelectorAll('[data-menu-submenu]').forEach(submenu => {
                    submenu.style.top = alertMessage.offsetHeight + headerHeight + 'px';
                });
            } else {
                document.querySelectorAll('[data-menu-submenu]').forEach(submenu => {
                    submenu.style.top = headerHeight + 'px';
                });
            }
            }, 10);
        });

    }

    /**
	 * Enable global overlay
     * 
     * @return {undefined}
	 */
    enableGlobalOverlay()  {

        if (window.screenMode == 'desktop-large') {
            document.querySelector('[data-global-overlay]').classList.remove('hidden');
        }
    }

    /**
	 * Disable global overlay
     * 
     * @return {undefined}
	 */
    disableGlobalOverlay() {

        if (window.screenMode == 'desktop-large') {
            document.querySelector('[data-global-overlay]').classList.add('hidden');
        }
    }
}

customElements.define(customElements.component, ComponentMenu);

}
